import React from 'react';

import { copyToClipboard } from 'common/utils/clipboard.utils';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

import Icon from 'components/base/Icon';
import { Flex } from 'components/base/layout-components';

const IconWrapper = styled.div`
  svg > path {
    stroke: ${({ color }) => getColor(color)};
  }
`;
const TextWrapper = styled(Flex)`
  font-size: 1.5rem;
  align-items: center;
`;
const IconContainerWrapper = styled.div`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? getColor(backgroundColor) : null};
  padding-bottom: 0.3rem;
  padding-top: 0.6rem;
  border-radius: 3px;
  cursor: pointer;
  padding-left: 0.7rem;
  padding-right: 0.7rem;
`;
const TextFieldWrapper = styled(Flex)`
  border: ${({ addBorder }) =>
    addBorder ? `solid 1px ${getColor('botticelli')};` : null};
  border-radius: 4px;
  padding-left: ${({ paddingLeftEnabled }) =>
    paddingLeftEnabled ? `0.7rem` : null};
  max-width: 42rem;
  color: ${getColor('osloGray')};
  justify-content: space-between;
`;

const VisibilityIcon = ({ visible, toggleVisibility }) => {
  return (
    <IconContainerWrapper onClick={toggleVisibility}>
      <IconWrapper
        data-testid='hide-show-copy-text-hide-icon-wrapper'
        color='shuttleGray'
      >
        {visible ? (
          <Icon data-testid='hide-show-copy-text-hide-icon' name='hideIcon' />
        ) : (
          <Icon data-testid='hide-show-copy-text-view-icon' name='viewIcon' />
        )}
      </IconWrapper>
    </IconContainerWrapper>
  );
};

const CopyIcon = ({ toggleSnackBar, value }) => {
  return (
    <IconContainerWrapper
      backgroundColor='chambray'
      data-cy='hide-show-copy-text-copy-icon-data-cy'
      onClick={() => copyToClipboard({ toggleSnackBar, value })}
    >
      <IconWrapper
        data-testid='hide-show-copy-text-copy-icon'
        borderLeft={true}
        color='white'
        backgroundColor='chambray'
      >
        <Icon data-testid='hide-show-copy-text-view-icon' name='copyIcon' />
      </IconWrapper>
    </IconContainerWrapper>
  );
};

const getHiddenValue = ({ prefix = '', hiddenCharacter, length }) => {
  const stringLength = length - prefix?.length;
  const hiddenArray = Array.from(
    { length: stringLength },
    (_, i) =>
      `<span style="margin-left:0.3rem;font-size:2rem">${hiddenCharacter}</span>`
  );
  return prefix + `<div> ${hiddenArray.join('')} </div>`;
};

const HideShowCopyTextField = ({
  value,
  toggleSnackBar,
  showCopy = true,
  showVisibilityToggle = true,
  initiallyVisible = true,
  alwaysShowBorder = false,
  hiddenCharacter = '*',
  hiddenPrefix = '',
  stringLength = 32,
  paddingLeftEnabled = true
}) => {
  const [visible, setVisible] = React.useState(initiallyVisible);

  React.useEffect(() => {
    setVisible(initiallyVisible);
  }, [initiallyVisible]);

  const toggleVisibility = () => setVisible(!visible);

  const getText = () => {
    if (visible) return value || '';
    return getHiddenValue({
      prefix: hiddenPrefix,
      length: stringLength,
      hiddenCharacter
    });
  };

  return (
    <TextFieldWrapper
      data-testid='hide-show-copy-text-field-wrapper'
      addBorder={showCopy || showVisibilityToggle || alwaysShowBorder}
      paddingLeftEnabled={paddingLeftEnabled}
    >
      <TextWrapper dangerouslySetInnerHTML={{ __html: getText() }} />
      <Flex>
        {showVisibilityToggle && (
          <VisibilityIcon
            visible={visible}
            toggleVisibility={toggleVisibility}
          />
        )}
        {showCopy && <CopyIcon value={value} toggleSnackBar={toggleSnackBar} />}
      </Flex>
    </TextFieldWrapper>
  );
};

export default HideShowCopyTextField;
